import React, { Component } from "react";
import { StyleSheet, Modal, View, Text, TouchableOpacity, TextInput, Platform, ScrollView } from "react-native";
import Icon from "react-native-vector-icons/MaterialIcons";
import { MaterialCommunityIcons, MaterialIcons } from "@expo/vector-icons";
import colors from "../../constants/colors";
import { formatStringNumber, getComponent, getComponentByanotherComponentId, getTotalSelected, sanitizeRecipeNumericInput, simpleAlert, validateDecimals, isPlaceholderLotObject } from "../../utils";
import { isMobileWeb } from "../../utils/mobileWeb";
import BarcodeScannerComponent from "./BarCodeScannerComponent";
import {
    exceedsRemainingLotAmount,
    findBlockingAllocation,
    getAllocationLotLabel,
    getRemainingLotAmount,
    isLotFullyAllocated,
} from "../../utils/shipmentAllocations";

class LotsByLocation extends Component {
    constructor(props) {
        super(props);
        this._interval = null;
        const amount = props.amount != null && props.amount !== "" ? parseFloat(formatStringNumber(String(props.amount))) : undefined;
        this.state = {
            value: "",
            height: 50,
            heightIOS: 27,
            filtered: props.options ? props.options : [],
            lotsSelected: this.setLotsSelected(props.lotsSelected, JSON.parse(JSON.stringify(props.options)), isNaN(amount) ? undefined : amount, props.units),
            scan: false,
            height: 30,
            editQty: false,
            modalVisible: false
        };
    }
    componentWillUnmount() {
        if (this._interval) clearInterval(this._interval);
    }
    /* UNSAFE_componentWillReceiveProps(nextProps) {
        if (nextProps?.show != this.props.show && nextProps.show) {
            this.setState({
                lotsSelected: this.setLotsSelected(nextProps.lotsSelected)
            })
        }
    } */
    setInitialState() {
        this.setState({
            value: "",
            height: 50,
            heightIOS: 27,
            filtered: [],
            lotsSelected: [],
            height: 30,
            editQty: false
        });
    }
    setLotsSelected(lotsSelected, options, amount, units) {
        var newLotsSeledted = [];
        var numAmount = amount != null && amount !== "" ? parseFloat(formatStringNumber(String(amount))) : undefined;
        if (numAmount != null && isNaN(numAmount)) numAmount = undefined;
        if (typeof lotsSelected == "string") {
            newLotsSeledted = [{
                lot: lotsSelected,
                historial: [],
                minDate: "",
                production_date: "",
                totalAmount: numAmount != null ? (numAmount % 1 !== 0 && !validateDecimals(String(numAmount))) ? Number(numAmount.toFixed(3)) : numAmount : 0,
                editedAmount: numAmount != null ? numAmount : 0,
                isNew: true,
                units
            }];
        } else {
            if(lotsSelected?.length > 0 && lotsSelected[0] == "default_lot"){
                if(typeof options == "object" && options?.length > 0){
                    var selectedAmount = (numAmount != null && !isNaN(numAmount)) ? numAmount : 0;
                    options.map((option)=>{
                        if(option?.totalAmount > 0 && selectedAmount > 0){
                            if(option?.historial){
                                //Need to map the historial from the last to the first
                                option.historial.reverse().map((batch)=>{
                                    if(batch?.amount > 0 && selectedAmount > 0){
                                        if((selectedAmount - batch?.amount) < 0){
                                            batch.editedAmount = (selectedAmount % 1 !== 0 && !validateDecimals(String(selectedAmount))) ? Number(selectedAmount.toFixed(3)) : selectedAmount;
                                        }
                                        selectedAmount -= batch?.amount;
                                    }else{
                                        batch.hide = true;
                                    }
                                    return batch;
                                });
                            }
                            newLotsSeledted.push(option); 
                        }
                    })
                }else{
                    newLotsSeledted = [{
                        lot: "",
                        historial: [],
                        minDate: "",
                        production_date: "",
                        totalAmount: numAmount != null ? (numAmount % 1 !== 0 && !validateDecimals(String(numAmount))) ? Number(numAmount.toFixed(3)) : numAmount : 0,
                        editedAmount: numAmount != null ? numAmount : 0,
                        isNew: true,
                        units
                    }];
                }
            }else{
                newLotsSeledted = JSON.parse(JSON.stringify(lotsSelected));
                if (Array.isArray(newLotsSeledted) && numAmount != null && !Number.isNaN(numAmount)) {
                    newLotsSeledted = newLotsSeledted.map((lot) => {
                        if (isPlaceholderLotObject(lot)) {
                            const current = parseFloat(lot.editedAmount);
                            if (!lot.editedAmount || Number.isNaN(current) || current === 0) {
                                return {
                                    ...lot,
                                    editedAmount: (numAmount % 1 !== 0 && !validateDecimals(String(numAmount))) ? Number(numAmount.toFixed(3)) : numAmount,
                                    totalAmount: (numAmount % 1 !== 0 && !validateDecimals(String(numAmount))) ? Number(numAmount.toFixed(3)) : numAmount,
                                };
                            }
                        }
                        return lot;
                    });
                }
            }
        }
        return newLotsSeledted;
    }
    componentWillReceiveProps(nextProps) {
        const lotsChanged = nextProps.lotsSelected != this.props.lotsSelected;
        const amountChanged = nextProps.amount != this.props.amount;
        if (lotsChanged || amountChanged) {
            const amount = nextProps.amount != null && nextProps.amount !== "" ? parseFloat(formatStringNumber(String(nextProps.amount))) : undefined;
            this.setState({ lotsSelected: this.setLotsSelected(nextProps.lotsSelected, JSON.parse(JSON.stringify(nextProps.options || [])), isNaN(amount) ? undefined : amount, nextProps.units) });
        }
    }
    selectBatch(option, batch, isNew, batchIndex) {
        const { lotsSelected } = this.state;
        const { isRecipe, isShipmentLog } = this.props;
        var foundLot = null
        if (lotsSelected && typeof lotsSelected == "object") foundLot = lotsSelected.find((lotcode) => lotcode.lot == option.lot);
        if (foundLot && !isNew && !isRecipe && !isShipmentLog) {
            //simpleAlert("", "This lot code was already selected", "Accept")
            return;
        }
        if (!isNew && this.isShipmentLotAllocated(option)) {
            this.showAlreadyAllocatedShipmentAlert(option);
            return;
        }
        var newLotsSelected = lotsSelected && typeof lotsSelected == "object" ? JSON.parse(JSON.stringify(lotsSelected)) : [];
        if (isNew) {
            newLotsSelected.push({
                historial: [],
                lot: "",
                minDate: "",
                units: option?.units,
                production_date: "",
                totalAmount: 0,
                editedAmount: 0,
                isNew: true
            });
        } else {
            if(foundLot && (isRecipe || isShipmentLog)){
                newLotsSelected[lotsSelected.findIndex((lotcode) => lotcode.lot == option.lot)] = this.editSelectedBatch(foundLot, true, batchIndex);
                //newLotsSelected.push(option);
            }else{
                if(isRecipe || isShipmentLog){
                    option = this.editSelectedBatch(option, false, batchIndex);
                }else{
                    option = this.editSelectedBatch(option, false, -1);
                }
                newLotsSelected.push(option);
            }
        }
        this.setState({ lotsSelected: newLotsSelected, editQty: true }, () => {
            this.props.onSelect(newLotsSelected, batch?.location)
        });
    }
    getShipmentAllocationOptions(option, batch) {
        const { currentSubmissionId, name } = this.props;
        const lotSource = option || batch;
        return {
            lot: lotSource?.lot || option?.lot || "",
            batchId: batch?.batchId || batch?._id || batch?.id || option?.batchId || option?._id || option?.id || null,
            itemName: name || "",
            currentSubmissionId,
        };
    }
    getRemainingAmountForLot(option, batch) {
        const { alreadyAllocatedShipmentLots } = this.props;
        const stockSource = batch || option;
        return getRemainingLotAmount(
            stockSource,
            alreadyAllocatedShipmentLots,
            this.getShipmentAllocationOptions(option, batch)
        );
    }
    isShipmentLotAllocated(option) {
        const { isShipmentLog, alreadyAllocatedShipmentLots } = this.props;
        if (!isShipmentLog || !alreadyAllocatedShipmentLots?.length || !option) return false;
        const lotNorm = (option.lot || "").toString().trim().toLowerCase();
        const batchId = option.batchId || option._id || option.id || null;
        // Empty lots are still allocatable; only skip when there is no lot and no batch to match.
        if ((!lotNorm || lotNorm === "default_lot") && !batchId) return false;
        return isLotFullyAllocated(
            option,
            alreadyAllocatedShipmentLots,
            this.getShipmentAllocationOptions(option)
        );
    }
    findAllocatedShipmentLot(option, batch) {
        const { alreadyAllocatedShipmentLots } = this.props;
        if (!alreadyAllocatedShipmentLots?.length) return null;
        return findBlockingAllocation(
            alreadyAllocatedShipmentLots,
            this.getShipmentAllocationOptions(option, batch)
        );
    }
    showAlreadyAllocatedShipmentAlert(option) {
        const { openAlert, name } = this.props;
        const allocated = this.findAllocatedShipmentLot(option) || {
            item: name || "",
            lot: option?.lot || "",
            quantity: option?.editedAmount != null ? option.editedAmount : option?.amount,
        };
        var item = allocated.item || name || "";
        var qty = allocated.quantity != null ? allocated.quantity : "";
        var lot = getAllocationLotLabel(allocated, option?.lot) || option?.lot || "";
        if(qty)qty = "quantity: " + qty;
        if(lot)lot = "lot: " + lot;
        const itemPart = [item, qty, lot].filter((v) => v !== "" && v != null).join(", ");
        const refParts = [];
        if (allocated.referenceNumber) refParts.push(allocated.referenceNumber);
        if (allocated.submission_id) refParts.push(allocated.submission_id);
        const refText = refParts.length ? " " + refParts.join(" / ") : "";
        const message =
            "The selected item: " +
            itemPart +
            " has already been allocated to another Invoice or Shipment Log: " +
            refText +
            " and cannot be added to this shipment.";
        if (openAlert) openAlert(true);
        simpleAlert(
            "Inventory Already Allocated",
            message,
            "OK",
            null,
            null,
            () => { if (openAlert) openAlert(false); }
        );
    }
    
    editLotCode(idx, type, value, subIdx) {
        const { lotsSelected } = this.state;
        const { isShipmentLog, alreadyAllocatedShipmentLots } = this.props;
        var newLotsSelected = JSON.parse(JSON.stringify(lotsSelected));
        if(!validateDecimals(value))return;

        if (type == "lotcode") {
            newLotsSelected[idx].lot = value;
        } else {
            if (isShipmentLog && alreadyAllocatedShipmentLots?.length) {
                const lotOption = newLotsSelected[idx];
                const batch = subIdx != null ? lotOption?.historial?.[subIdx] : null;
                const stockSource = batch || lotOption;
                const allocOpts = this.getShipmentAllocationOptions(lotOption, batch);
                if (exceedsRemainingLotAmount(value, stockSource, alreadyAllocatedShipmentLots, allocOpts)) {
                    this.showAlreadyAllocatedShipmentAlert(lotOption);
                    return;
                }
            }
            if (subIdx != null) {
                newLotsSelected[idx].historial[subIdx].editedAmount = value;
            } else {
                newLotsSelected[idx].editedAmount = value;
            }
        }
        this.setState({ lotsSelected: newLotsSelected, editQty: true }, () => {
            this.props.onSelect(newLotsSelected, null)
        });
    }
    quitBatch(option, isNew, batchIndex) {
        const { lotsSelected } = this.state;
        const { isRecipe, isShipmentLog } = this.props;
        var foundLot = -1;
        if (isNew) foundLot = lotsSelected.findIndex((lotcode) => lotcode.lot == option.lot && lotcode.isNew); else foundLot = lotsSelected.findIndex((lotcode) => lotcode.lot == option.lot);
        var newLotsSelected = JSON.parse(JSON.stringify(lotsSelected));
        if (foundLot > -1) {
            if(isNew || (!isRecipe && !isShipmentLog)){
                newLotsSelected.splice(foundLot, 1);
            }else{
                var lot = newLotsSelected[foundLot];
                var quitLot = true;
                if(lot){
                    lot.historial.map((batch, idx) => {
                        if(idx != batchIndex && !batch.hide)quitLot = false;
                    })
                }
                if(quitLot)newLotsSelected.splice(foundLot, 1); else{
                    var batch = newLotsSelected[foundLot].historial[batchIndex];
                    batch.hide = true;
                    delete batch.editedAmount;
                    newLotsSelected[foundLot].historial[batchIndex] = batch;
                } 
            }
        }
        this.setState({ lotsSelected: newLotsSelected, editQty: true }, () => {
            this.props.onSelect(newLotsSelected, null)
        });
    }
    handleBarCodeScanned(val) {
        const { lotsSelected } = this.state;
        const { options } = this.props;
        var foundInSelectedLots = null;
        if (lotsSelected && typeof lotsSelected == "object") foundInSelectedLots = lotsSelected.find((lotcode) => lotcode.lot == val);
        this.showScanner(false);

        if (foundInSelectedLots) {
            simpleAlert("", "This lot code was already selected", "Accept", "", "", null);
            return;
        }
        var foundLot = options.find((lotcode) => lotcode.lot == val);
        if (foundLot && this.isShipmentLotAllocated(foundLot)) {
            this.showAlreadyAllocatedShipmentAlert(foundLot);
            return;
        }
        var newLotsSelected = lotsSelected && typeof lotsSelected == "object" ? JSON.parse(JSON.stringify(lotsSelected)) : [];

        if (foundLot) {
            foundLot = this.editSelectedBatch(foundLot, false, -1);
            newLotsSelected.push(foundLot);
        } else {
            newLotsSelected.push({
                lot: val,
                historial: [],
                minDate: "",
                production_date: "",
                totalAmount: 0,
                editedAmount: 0,
                isNew: true
            })
        }

        this.setState({ lotsSelected: newLotsSelected, editQty: true }, () => {
            this.props.onSelect(newLotsSelected, null)
        });
    }
    search(value) {
        const { options } = this.props;
        if(this._interval)clearInterval(this._interval);
        if (value) {
            var filtered = options.filter((option) => option.lot.toLowerCase().includes(value.toLowerCase()));
            this._interval = setInterval(() => {
                clearInterval(this._interval);
                var found = filtered.find((option) => option.lot.toLowerCase().trim() == value.toLowerCase().trim());
                if(found){
                    if (this.isShipmentLotAllocated(found)) {
                        this.showAlreadyAllocatedShipmentAlert(found);
                        this.setState({ filtered: this.props.options });
                        return;
                    }
                    found.historial.map((batch, idx) => {
                        if(!batch?.hide)this.selectBatch(found, batch, false, idx)
                    });
                    this.setState({ filtered: this.props.options });
                }
            }, 500);
            this.setState({ filtered });
        } else {
            this.setState({ filtered: options });
        }
    }
    
    renderInput(value, onchange, type, width) {
        const handleChange = (type === "numeric")
            ? (text) => onchange(sanitizeRecipeNumericInput(text))
            : onchange;
        const kb = type === "numeric" ? "decimal-pad" : "default";
        return <TextInput value={value} onChangeText={handleChange} keyboardType={kb} style={{ width: width, textAlign: 'center', borderWidth: 1, borderRadius: 10, borderColor: colors.orange, color: colors.orange }} />
    }
    showScanner(val) {
        this.setState({ scan: val })
    }
    renderAddLotBtn(units) {
        return <TouchableOpacity style={{ ...styles.tableHeader, borderBottomWidth: 0 }}
            onPress={() => this.selectBatch({ lot: "", units }, null, true)}
        >
            <Text style={{ ...styles.tableBodyTxt, width: '15%', textAlign: 'left' }}>
                <MaterialCommunityIcons name="plus-circle-outline" style={{ ...styles.rowIcon, color: colors.add }} />
            </Text>
        </TouchableOpacity>
    }
    amountQtyAlert(requiredAmount, totalAmount, units) {
        const { openAlert } = this.props;
        openAlert(true);
        simpleAlert("", "The amount entered does not match the required quantity.<br /><br /><b>Required: " + parseFloat(requiredAmount).toFixed(3) + " " + units + ".<br />Entered: " + parseFloat(totalAmount).toFixed(3) + " " + units + "</b>.<br /><br />This will reduce inventory by the entered amount.<br />Make sure this change is intentional before proceeding", "Got it 1", "warning", "red",
            () => openAlert(false)
        )
    }
    renderAmountAlert(modalVisible, requiredAmount, totalAmount, units) {
        return (<Modal
            animationType="slide"
            transparent={true}
            visible={modalVisible}
            onRequestClose={() => {
                this.setState({ modalVisible: false })
            }}
        >
            <View style={styles.centeredView}>
                <View style={styles.modalView}>
                    <Text style={styles.modalText}><MaterialIcons name="warning-amber" size={50} style={{ color: colors.quit }} /></Text>
                    <Text style={styles.modalText}>The amount entered does not match the required quantity</Text>
                    <Text style={{...styles.modalText, fontWeight: '700'}}>Required: {parseFloat(requiredAmount)} {units}</Text>
                    <Text style={{...styles.modalText, fontWeight: '700'}}>Entered: {parseFloat(totalAmount)} {units}</Text> 
                    <Text style={styles.modalText}>This will reduce inventory by the entered amount.</Text> 
                    <Text style={styles.modalText}>Make sure this change is intentional before proceeding.</Text> 
                    <TouchableOpacity style={styles.modalBtn} onPress={()=> this.setState({ modalVisible: false })}>
                        <Text style={{...styles.modalText, fontWeight: '700', marginBottom: 0, color: 'white'}}>Got it</Text> 
                    </TouchableOpacity>
                </View>
            </View>
        </Modal>)
    }
    editSelectedBatch(option, found, batchIndex){
        const {lotsSelected} = this.state;
        const { requiredAmount, isShipmentLog } = this.props;
        var amountSelected = parseFloat(getTotalSelected(lotsSelected))
        var quantity = parseFloat(requiredAmount) - amountSelected;
        if (isShipmentLog) {
            const remaining = this.getRemainingAmountForLot(option);
            if (remaining >= 0 && quantity > remaining) quantity = remaining;
        }
        
        if(quantity > 0 || found){
            if(option?.historial){
                option.historial.map((batch, index)=>{
                    if(found){
                        if(index == batchIndex)batch.hide = false;
                    }else{
                        if(quantity > 0 && (batchIndex == index && batchIndex >= 0)){
                            var maxTake = parseFloat(batch?.amount) || 0;
                            if (isShipmentLog) {
                                const remainingForBatch = this.getRemainingAmountForLot(option, batch);
                                if (remainingForBatch >= 0 && maxTake > remainingForBatch) maxTake = remainingForBatch;
                            }
                            var rest = maxTake - quantity;
                            if (rest >= 0) {
                                batch.editedAmount = (quantity % 1 > 0 && !validateDecimals(quantity.toString())) ? quantity.toFixed(3) : quantity;
                                quantity = 0;
                            } else {
                                quantity = rest * -1;
                                batch.editedAmount = (maxTake % 1 > 0 && !validateDecimals(maxTake.toString())) ? parseFloat(maxTake).toFixed(3) : maxTake;
                            }
                        }else{
                          batch.hide = true;
                        }
                    }
                    
                    return batch;
                })
            }
        }else if(batchIndex >= 0){
            option.historial.map((batch, index)=>{
                if(index == batchIndex){
                    batch.hide = false;
                    if (isShipmentLog) {
                        var maxTake = parseFloat(batch?.amount) || 0;
                        const remainingForBatch = this.getRemainingAmountForLot(option, batch);
                        if (remainingForBatch >= 0 && maxTake > remainingForBatch) maxTake = remainingForBatch;
                        if (batch.editedAmount == null || batch.editedAmount === "") {
                            batch.editedAmount = (maxTake % 1 > 0 && !validateDecimals(maxTake.toString())) ? parseFloat(maxTake).toFixed(3) : maxTake;
                        } else if (exceedsRemainingLotAmount(batch.editedAmount, batch, this.props.alreadyAllocatedShipmentLots, this.getShipmentAllocationOptions(option, batch))) {
                            batch.editedAmount = (maxTake % 1 > 0 && !validateDecimals(maxTake.toString())) ? parseFloat(maxTake).toFixed(3) : maxTake;
                        }
                    }
                } else batch.hide = true;

                return batch;
            });
        }
        return option;
    }
    render() {
        const { options, onBack, name, position, placeholder, units, amount, requiredAmount, isInventoryType, isReceivingLog, complete_date } = this.props;
        const { value, filtered, lotsSelected, scan, editQty, modalVisible } = this.state;
        const headers = ['', 'Lot Code', 'Amount', 'Location'];
        var lotsUnits = units;
        const showMobileScan = Platform.OS !== "web" || isMobileWeb();
        const hideAvailableStock = !!(isReceivingLog || complete_date);
        return <Modal animationType="slide" transparent={false} visible={true} backdropColor={'white'}>
            {scan && showMobileScan && (
            <BarcodeScannerComponent
                onBarCodeScanned={(e) => this.handleBarCodeScanned(e)}
                closeScanner={() => this.showScanner(false)}
                style={styles.absoluteFillObject}
            />)}
            <View style={{ backgroundColor: colors.gray, height: '100%' }}>
                <View style={styles.cardContainer}>
                    <View style={{ ...styles.headerContainer, borderRadius: 20 }}>
                        <TouchableOpacity style={styles.btnBack} onPress={() => {
                            onBack(editQty, getTotalSelected(lotsSelected), (parseFloat(getTotalSelected(lotsSelected)) < parseFloat(requiredAmount) || parseFloat(getTotalSelected(lotsSelected)) > parseFloat(requiredAmount)));
                            setTimeout(() => {
                                this.setInitialState();
                            }, 200);
                        }}>
                            <Text style={styles.btnBackIcon}>
                                <MaterialIcons name="arrow-back-ios" size={25} />
                            </Text>
                        </TouchableOpacity>
                        <Text style={{...styles.headerTxt, flex: requiredAmount ? 3 : 6}}>
                            {name}
                        </Text>
                        {requiredAmount && <Text style={styles.headerTxt}>
                            Required Amount: {requiredAmount} {units}
                        </Text>}
                    </View>
                    <View style={{ flex: 1, paddingInline: 10 }}>
                        <View style={{ flex: 10 }}>
                            {lotsSelected && typeof lotsSelected == "object" ?
                                <View style={{ maxHeight: '100%' }}>
                                    <View style={{ ...styles.tableHeader, borderBottomWidth: 1, borderBottomColor: colors.orange }}>
                                        {headers.map((header, idx) => {
                                            if (idx <= 2) {
                                                return <Text key={idx} style={{ ...styles.tableHeaderTxt, width: idx == 0 ? '15%' : idx == 1 ? '35%' : '50%' }}>
                                                    {header}
                                                </Text>
                                            }
                                        })}
                                    </View>
                                    {lotsSelected.length ? <ScrollView style={{ ...styles.tableBody }}>
                                        {
                                            lotsSelected.map((option, idxOpt) => {
                                                if (!option?.isNew && option?.historial?.length > 0) {
                                                    return option.historial.map((batch, idx) => {
                                                        if (batch?.hide) return null;
                                                        if (batch?.units && !isInventoryType && !lotsUnits) lotsUnits = batch?.units;
                                                        return <View key={idx} style={styles.tableHeader}>
                                                            <View style={{ ...styles.tableBodyTxt, width: '15%', textAlign: 'left', paddingTop: 5 }}>
                                                                <TouchableOpacity onPress={() => this.quitBatch(option, false, idx)} ><MaterialIcons name="highlight-remove" style={{ ...styles.rowIcon, color: colors.quit }} /></TouchableOpacity>
                                                            </View>
                                                            <View style={{ ...styles.tableBodyTxt, width: '35%' }}>
                                                                <Text style={{ textAlign: 'center' }}>
                                                                    {option.lot && typeof option.lot == "string" ? option.lot : "No Lot"}
                                                                </Text>
                                                            </View>
                                                            <View style={{ ...styles.tableBodyTxt, width: '50%', flexDirection: 'row' }}>
                                                                <Text style={{ textAlign: 'center' }}>
                                                                    {this.renderInput(batch?.editedAmount || batch?.editedAmount == "" ? batch?.editedAmount : (batch?.amount % 1 > 0  && !validateDecimals(batch.amount.toString())) ? batch.amount.toFixed(3) : batch.amount, (value) => this.editLotCode(idxOpt, "amount", value, idx), "numeric", "50%")} <View style={styles.unitsContainer}><Text>{isInventoryType ? units : batch?.units}</Text></View>
                                                                </Text>
                                                            </View>
                                                        </View>;
                                                    })
                                                } else if (option?.isNew) {
                                                    return <View key={idxOpt} style={styles.tableHeader}>
                                                        <View style={{ ...styles.tableBodyTxt, width: '15%', textAlign: 'left', paddingTop: 5 }}>
                                                            <TouchableOpacity onPress={() => this.quitBatch(option, true, -1)}><MaterialIcons name="highlight-remove" style={{ ...styles.rowIcon, color: colors.quit }} /></TouchableOpacity>
                                                        </View>
                                                        <Text style={{ ...styles.tableBodyTxt, width: '35%', paddingTop: option?.units ? 13 : 10 }}>
                                                            {this.renderInput(option?.lot, (value) => this.editLotCode(idxOpt, "lotcode", value), "default", "90%")}
                                                        </Text>
                                                        <View style={{ ...styles.tableBodyTxt, width: '50%', flexDirection: 'row' }}>
                                                            <Text style={{ textAlign: 'center' }}>
                                                                {this.renderInput(option?.editedAmount, (value) => this.editLotCode(idxOpt, "amount", value, null), "numeric", "50%")} <View style={styles.unitsContainer}><Text>{option?.units}</Text></View>
                                                            </Text>
                                                        </View>
                                                    </View>;
                                                }
                                            })
                                        }
                                        {this.renderAddLotBtn(units)}
                                    </ScrollView> : this.renderAddLotBtn(units)}
                                </View>
                                : this.renderAddLotBtn(units)}
                        </View>
                        <View style={{ flex: 2, padding: 10, flexShrink: 0 }}>
                            <View style={{ flexDirection: "row", justifyContent: "flex-end", alignItems: "center", flexWrap: "wrap" }}>
                                {(parseFloat(getTotalSelected(lotsSelected)) < parseFloat(requiredAmount) || parseFloat(getTotalSelected(lotsSelected)) > parseFloat(requiredAmount)) && (
                                    <TouchableOpacity onPress={() => this.setState({ modalVisible: true })} style={styles.warningContainer}>
                                        <MaterialIcons name="warning-amber" size={25} style={styles.warningIcon} />
                                        <Text style={styles.warningTxt}>The Amount does not match</Text>
                                    </TouchableOpacity>
                                )}
                                <Text style={{ textAlign: "right", fontSize: 18, fontWeight: "700", marginLeft: 8 }}>
                                    Total: {getTotalSelected(lotsSelected)} {lotsUnits}
                                </Text>
                            </View>
                            {showMobileScan && isReceivingLog && (
                                <View style={{ alignItems: "flex-end", marginTop: 10 }}>
                                    <TouchableOpacity
                                        onPress={() => this.showScanner(true)}
                                        style={styles.scanFab}
                                    >
                                        <MaterialIcons name="qr-code-scanner" color="#fff" size={26} />
                                    </TouchableOpacity>
                                </View>
                            )}
                        </View>
                    </View>
                    {!hideAvailableStock && <View style={{ flex: 2, paddingInline: 10, paddingTop: 12, flexShrink: 0 }}>
                        <View style={styles.stockHeaderRow}>
                            <Text style={[styles.title, styles.stockHeaderTitle]} numberOfLines={2}>Available Stock on Hand</Text>
                            {showMobileScan && (
                                <TouchableOpacity
                                    onPress={() => this.showScanner(true)}
                                    style={styles.scanFab}
                                >
                                    <MaterialIcons name="qr-code-scanner" color="#fff" size={26} />
                                </TouchableOpacity>
                            )}
                        </View>
                        <View style={{ ...styles.searchView, borderColor: colors.orange }}>
                            <Text style={{ ...styles.searchIcon, borderColor: colors.orange }}>
                                <MaterialIcons name="search" size={25} />
                            </Text>
                            <TextInput
                                value={value}
                                onContentSizeChange={(event) => {
                                    if (event.nativeEvent.contentSize.height == 0) {
                                        if (this.props.placeholder == '') {
                                            this.setState({ height: 30 })
                                        }
                                        this.setState({ height: event.nativeEvent.contentSize.height });
                                    } else {
                                        setTimeout(() => {
                                            this.setState({ height: event.nativeEvent.contentSize.height });
                                        }, 5)
                                    }
                                }}
                                style={{
                                    ...styles.input,
                                    color: colors.orange,
                                    height: this.state.height
                                }}
                                multiline={true}
                                placeholder={placeholder ? placeholder : ""}
                                placeholderTextColor={colors.orange}
                                onChangeText={(val) => {
                                    this.setState({ value: val });
                                    this.search(val);
                                }}
                            />
                        </View>
                        <View style={{ ...styles.tableView, maxHeight: '65%' }}>
                            <View style={{ ...styles.tableHeader, borderBottomWidth: 1, borderBottomColor: colors.orange }}>
                                {headers.map((header, idx) => {
                                    return <Text key={idx} style={{ ...styles.tableHeaderTxt, width: idx == 0 ? '15%' : '28.3%' }}>
                                        {header}
                                    </Text>
                                })}
                            </View>
                            {filtered.length ? <ScrollView style={styles.tableBody}>
                                {
                                    filtered.map((option) => {
                                        if (option?.historial) {
                                            return option.historial.map((batch, idx) => {
                                                return <TouchableOpacity key={idx} style={{ ...styles.tableHeader }} onPress={() => this.selectBatch(option, batch, false, idx)}>
                                                    <Text style={{ ...styles.tableBodyTxt, width: '15%', textAlign: 'left', paddingTop: 5 }}>
                                                        <MaterialCommunityIcons name="plus-circle-outline" style={{ ...styles.rowIcon, color: colors.add }} />
                                                    </Text>
                                                    <Text style={styles.tableBodyTxt}>
                                                        {option.lot && typeof option.lot == "string" ? option.lot : "No Lot"}
                                                    </Text>
                                                    <View style={{ ...styles.tableBodyTxt, flexDirection: 'row' }}>
                                                        <Text >
                                                            {(batch?.amount % 1 > 0  && !validateDecimals(batch.amount.toString())) ? batch.amount.toFixed(3) : batch.amount}
                                                        </Text>
                                                        <Text >
                                                            {" "}{isInventoryType ? units : batch?.units}
                                                        </Text>
                                                    </View>
                                                    <Text style={styles.tableBodyTxt}>
                                                        {batch.completeLocation}
                                                    </Text>
                                                </TouchableOpacity>;
                                            })
                                        }
                                    })
                                }
                            </ScrollView> : <View><Text style={{ textAlign: 'center', padding: 10 }}>Sorry, no lot codes were found.</Text></View>}
                        </View>
                    </View>}
                </View>
            </View>
            {this.renderAmountAlert(modalVisible, (parseFloat(requiredAmount) % 1 > 0  && !validateDecimals(requiredAmount.toString())) ? parseFloat(requiredAmount).toFixed(3) : parseFloat(requiredAmount), getTotalSelected(lotsSelected), lotsUnits)}
        </Modal>;
    }
}

export default LotsByLocation;

const styles = StyleSheet.create({
    headerContainer: {
        flexDirection: 'row',
        backgroundColor: 'white',
        paddingTop: Platform.OS == "ios" ? 35 : 15,
        paddingBottom: 5,
    },
    btnBack: {
        flex: 1
    },
    btnBackIcon: {
        padding: 10,
        color: colors.orange
    },
    headerTxt: {
        flex: 3,
        textAlign: 'center',
        padding: 10,
        fontSize: 18,
        //color: 'gray',
        fontWeight: '600',
        position: 'relative'
    },
    searchView: {
        backgroundColor: 'white',
        minHeight: 50,
        flexDirection: 'row',
        borderRadius: 15,
        paddingInline: 5,
        paddingVertical: 5,
        borderWidth: 1,
        marginInline: 10
    },
    tableView: {
        backgroundColor: 'white',
        flexDirection: 'column',
        marginTop: 20,
        borderRadius: 10,
        marginLeft: 5,
        marginRight: 5
    },
    input: {
        fontFamily: "Roboto",
        fontSize: 16,
        fontWeight: "400",
        padding: 10,
        flex: 9,
        //marginTop: 5,
        marginLeft: 5
    },
    searchIcon: {
        //flex: 1,
        paddingTop: 5,
        color: colors.orange,
        borderRadius: 50,
        padding: 5,
        borderWidth: 1,
        textAlign: 'center',
        //marginTop: 5
    },
    separatorContainer: {
        flexDirection: 'row',
        alignItems: 'center',
        transform: 'translateX(-10px)'
    },
    separator: {
        width: 2,
        height: '100%',
        backgroundColor: colors.orange,
        marginLeft: 10,
    },
    tableHeader: {
        flexDirection: 'row',
        paddingTop: 5,
        paddingBottom: 5,
        borderBottomColor: 'gray',
        borderBottomWidth: 1,
        paddingLeft: 10,
        paddingRight: 10,
    },
    tableHeaderTxt: {
        width: '30%',
        fontWeight: '600',
        fontSize: 18,
        textAlign: 'center'
    },
    tableBody: {
        flexDirection: 'column',
        //height: '50%'
    },
    tableBodyTxt: {
        width: '28.3%',
        textAlign: 'center',
        //justifyContent: 'center',
        paddingTop: 10
    },
    title: {
        fontSize: 18,
        fontWeight: 'bold',
        padding: 5
    },
    stockHeaderRow: {
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'space-between',
        marginBottom: 8,
        paddingHorizontal: 5,
        flexShrink: 0,
    },
    stockHeaderTitle: {
        flex: 1,
        marginRight: 8,
        paddingVertical: 4,
    },
    scanFab: {
        width: 50,
        height: 50,
        justifyContent: 'center',
        alignItems: 'center',
        borderRadius: 50,
        backgroundColor: colors.primary,
        flexShrink: 0,
    },
    rowIcon: {
        fontSize: 30,
    },
    unitsContainer: {
        flex: 2, justifyContent: 'flex-start', alignItems: 'center', padding: 3
    },
    cardContainer: { height: '100%', margin: 'auto', backgroundColor: 'white', marginInline: isMobileWeb() ? '5%' : '10%', marginTop: 10, marginBottom: 10, borderRadius: 20, padding: 10 },
    warningContainer: {
        backgroundColor: 'red',
        borderRadius: 20,
        paddingInline: 10,
        marginTop: 10,
        marginRight: 10,
        flexDirection: 'row',
    },
    warningIcon: {
        padding: 7,
        margin: 'auto',
        color: 'white'
    },
    warningTxt: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        color: 'white'
    },
    container: {
        flex: 1,
        justifyContent: 'center',
        alignItems: 'center',
    },
    centeredView: {
        flex: 1,
        justifyContent: 'center',
        alignItems: 'center',
        marginTop: 22,
    },
    modalView: {
        margin: 20,
        backgroundColor: 'white',
        borderRadius: 20,
        padding: 35,
        alignItems: 'center',
        shadowColor: '#000',
        shadowOffset: {
            width: 0,
            height: 2,
        },
        shadowOpacity: 0.25,
        shadowRadius: 4,
        elevation: 5,
    },
    modalText: {
        marginBottom: 15,
        textAlign: 'center',
        fontSize: 18
    },
    modalBtn:{
        backgroundColor: colors.orange,
        marginTop: 10,
        borderRadius: 20,
        padding: 15,
        paddingInline: 50
    }

})